// src/components/LanguageSwitcher.jsx
import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const options = [
    { value: 'gu', label: 'ગુજરાતી' },
    { value: 'en', label: 'English' },
    { value: 'hi', label: 'हिन्दी' },
    // { value: 'all', label: 'all' },
  ];

  return (
    // <div className="">
      <Select
        options={options}
        value={options.find(opt => opt.value === i18n.language)}
        onChange={(option) => i18n.changeLanguage(option.value)}
        isSearchable={false}
        styles={{
          control: (base) => ({
            ...base,
            width: '140px',
            minHeight: '35px',
            backgroundColor: '#ffffff',
            borderColor: '#cbd5e1',
            boxShadow: 'none',
            borderRadius: '8px',
          }),
          menu: (base) => ({
            ...base,
            width: '140px',
          }),
        }}
        classNamePrefix="react-select"
      />
    /* </div> */
  );
};

export default LanguageSwitcher;